/** @jsxImportSource @emotion/react */

import { useState } from 'react'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { TabsItem } from 'types/tabsItem'
import TabsNavigation from 'components/TabsNavigation'
import { PAT_KEYS } from 'constants/PATGenerators'
import * as classes from './styles'

const tabs: Array<TabsItem> = [
  { id: PAT_KEYS.AngleRanking, title: 'Angle Ranking' },
  { id: PAT_KEYS.CubeCounting, title: 'Cube-Counting' },
  { id: PAT_KEYS.HolePunching, title: 'Hole Punching' },
  { id: PAT_KEYS.Keyhole, title: 'Keyholes' },
  { id: PAT_KEYS.PatternFolding, title: 'Pattern Folding' },
]

export const DescriptionContent = () => {
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <>
      <TabsNavigation tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      <DescriptionForm page={`${DescriptionPages.PATGenerators}:${activeTab.id}`} />
    </>
  )
}
